// extracted by mini-css-extract-plugin
export default {"button":"Uvtob","hiddenLabel":"X4y6M"};